var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dkbr-icon"},[(_vm.text)?_c('span',{staticClass:"dkbr-icon_text",class:['dkbr-icon__text_'+_vm.textDir],domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_c('md-icon',{staticClass:"dkbr-icon_icon",class:[
            'md-primary',
            'md-size-'+_vm.size+'x',
            _vm.source == 'fa' ? 'fa' : undefined,
            _vm.source == 'fa' ? 'fa-'+_vm.name : undefined],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th}},[_vm._v(_vm._s(_vm.source == 'gg' ? _vm.name : undefined))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8f8f5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/icon/vue/Icon.vue
// module id = WWVF
// module chunks = 8